import InvoicesSection from './InvoicesSection';

export default InvoicesSection;